import Alpine from "alpinejs";
import mainProductImages from "./alpine/mainProductImages";
import mainProductTabs from "./alpine/mainProductTabs";
import productForm from "./alpine/productForm";
import { shared } from "./shared";
import { init as initCollection } from "./templates/collection";
import { init as initSearch } from "./templates/search";
import { init as initCarousel } from "./sections/products-carousel";
import { init as initProduct } from "./templates/product";
import { init as initLookbookPage } from "./templates/page.lookbook";
import { init as initCart } from "./templates/cart";
import { init as initAccount } from "./templates/account";
import { init as initLogin } from "./templates/login";
import { CustomerAddresses } from "./customer";
import { init as initAddresses } from "./templates/account-addresses";
import { init as initResetPassword } from "./templates/reset-password";
import { init as initContactsPage } from "./templates/page.contacts";
import { init as initPasswordProtectedPage } from "./templates/page.password-protected";
import { init as initRmaPage } from "./templates/page.rma";
/* import { init as initAboutPage } from "./templates/page.about";
 */
import { init as initPage } from "./templates/page";
async function main() {
  // Not sure it's needed
  /*   if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
    window.Shopify.routes = {};
  } */

  const { templateName, templateSuffix } = document.body.dataset;
  // Run logic required by all pages
  shared(templateName, templateSuffix);

  // Run logic required by specific templates
  if (templateName === "product") {
    Alpine.data("mainProductImages", mainProductImages);
    Alpine.data("mainProductTabs", mainProductTabs);
    Alpine.data("productForm", productForm);
    initProduct();
  } else if (templateName === "collection") {
    initCollection();
  } else if (templateName === "search") {
    initSearch();
  } else if (templateName === "page") {
    // All pages that has lookbook should have a template name that starts with 'lookbook'
    // ex. lookbook-aw22
    if (templateSuffix.includes("lookbook")) {
      initLookbookPage();
    } else if (templateSuffix.includes("contacts")) {
      initContactsPage();
    } else if (templateName === "page" && templateSuffix === "rma") {
      initRmaPage();
    } else if (templateName === "page" && templateSuffix.includes("password-protected")) {
      initPasswordProtectedPage();
    }
     /* else if (templateSuffix.includes("about")) {
      initAboutPage();
    } */
    // Init common sections for all pages
    initPage();
  } else if (templateName == "cart") {
    initCart();

    /* ACCOUNT RELATED PAGES */
  } else if (
    templateName == "account" ||
    templateName == "addresses" ||
    templateName == "order"
  ) {
    // common code for the layout
    initAccount();

    if (templateName == "addresses") {
      const addresses = new CustomerAddresses();
      initAddresses();
      // Setup adresses (code from Dawn)
    }
  } else if (templateName == "login") {
    initLogin();
  } else if (
    templateName == "reset_password" ||
    templateName == "register" ||
    templateName == "activate_account"
  ) {
    // both templates use the same code to make labels smaller when in focus
    initResetPassword();
  }


  //HEADER code session
  var header_height = document.getElementById('header-container').clientHeight;
  document.querySelector(':root').style.setProperty('--header-height', header_height+'px');

  initCarousel(); 

  Alpine.start();
}

document.addEventListener("DOMContentLoaded", main);
